import {useHistory} from '@aboutyou/router';
import {useEffect, useRef} from 'react';

export const useCloseFlyoutContentOnRouteChange = (closeFunc: () => void) => {
  const history = useHistory();
  const ref = useRef(history.location.pathname);
  const searchRef = useRef(history.location?.search);

  useEffect(() => {
    return history.listen(() => {
      if (
        history.location.pathname !== ref.current ||
        history.location.search !== searchRef.current
      ) {
        closeFunc();
        ref.current = history.location.pathname;
        searchRef.current = history.location.search;
      }
    });
  }, [closeFunc, history]);
};
